<p-select
  [options]="statusList"
  [multiple]="true"
  filterBy="label"
  [disabled]="disabled()"
  [ngModel]="statuses"
  (ngModelChange)="statuses = $event; onStatusChange($event)"
  appendTo="body"
  panelStyleClass="p-select-checkbox-options"
  placeholder="Status"
  [lazy]="true"
>
  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="statuses"
      [label]="chipLabel"
      [removable]="!disabled()"
      (removeItem)="removeStatus($event)"
    />
  </ng-template>
</p-select>
